// test1583
(1583 && 0);
